import { registerVueComponentAndAngularBindings } from '/vodalys/vvuejs'

import VrunFormLangTextfield from './VrunFormLangTextfield.vue'

registerVueComponentAndAngularBindings('vrun_form:lang_textfield:component', 'vrunFormLangTextfield', VrunFormLangTextfield)